import React from "react";

function DateFilterLedger({
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  handleApplyBtn,
}) {
  return (
    <>
      {/* Filter Bar */}
      <div className="filter-bar-customer-ledger no-print mt-3 d-flex gap-3 flex-wrap align-items-center">
        <label>From Date</label>
        <input
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
        />
        <label>To Date</label>
        <input
          type="date"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
        />
        <button className="btn-gold" onClick={handleApplyBtn}>
          Apply
        </button>
        <button
          className="btn-clear"
          onClick={() => {
            setFromDate("");
            setToDate("");
          }}
        >
          Clear
        </button>
      </div>
    </>
  );
}

export default DateFilterLedger;
